import { ProcessMessageTypeEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/process-message';

export type PaymentType =
  | 'Mastercard'
  | 'Visa'
  | 'UmonPay'
  | 'uatp'
  | 'Jcb'
  | 'Discover'
  | 'Dinners Club'
  | 'American Express';
export const PaymentTypeIcon: Record<PaymentType, string> = {
  Mastercard: 'ds-icon-card-mcard',
  Visa: 'ds-icon-card-visa',
  UmonPay: 'ds-icon-card-up',
  uatp: 'ds-icon-card-uatp',
  Jcb: 'ds-icon-card-jcb',
  Discover: 'ds-icon-card-discover',
  'Dinners Club': 'ds-icon-card-diners',
  'American Express': 'ds-icon-card-amex'
};
export type PaymentStatus = 'Confirmed' | 'Approved' | 'Rejected';
export const PaymentStatusColor: Record<PaymentStatus, ProcessMessageTypeEnum> = {
  Confirmed: ProcessMessageTypeEnum.SUCCESS,
  Approved: ProcessMessageTypeEnum.SUCCESS,
  Rejected: ProcessMessageTypeEnum.ERROR
};

export const currentLabelPaymentStatus: Record<PaymentStatus, string> = {
  Confirmed: 'booking_details_component.payment_details_component.payment_status_types.confirmed',
  Approved: 'booking_details_component.payment_details_component.payment_status_types.approved',
  Rejected: 'booking_details_component.payment_details_component.payment_status_types.declined'
};
